import React, {ErrorInfo} from 'react';

import {Description, ErrorArea, ErrorAreaRoot, ErrorName, ErrorStack, Root, Title} from './styled';

interface ErrorBoundaryState {
    error: Error | null;
    errorInfo: ErrorInfo | null;
}

export class ErrorBoundary extends React.Component<
    React.PropsWithChildren<{}>,
    ErrorBoundaryState
> {
    state: ErrorBoundaryState = {error: null, errorInfo: null};

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.setState({error, errorInfo});
    }

    render() {
        const {error, errorInfo} = this.state;

        if (!error || !errorInfo) {
            return this.props.children;
        }

        return (
            <Root>
                <Title>Something went wrong :(</Title>
                <Description>
                    Please contact support and provide the error details below.
                </Description>

                <ErrorAreaRoot>
                    <ErrorArea>
                        <ErrorName>{error.toString()}</ErrorName>
                        <ErrorStack>{errorInfo.componentStack}</ErrorStack>
                    </ErrorArea>
                </ErrorAreaRoot>
            </Root>
        );
    }
}
